import React from 'react';
import CompleteContainer from '../complete/container';
import CompleteContent from '../complete/content';
import CompleteDescription from '../complete/description';
import CompleteFooter from '../complete/footer';
import useTicketingComplete, {useDownloadTicketingComplete, useImpulseByClaimTicketingComplete} from '../complete/use-ticketing-complete';
import {CheckoutStateContext} from '../../../components/CheckoutContext';
import TicketingDownloadPopUp from '../complete/ticketing-download-pop-up';
import ImpulseStatusSubscription from '../complete/impulse-status-subscription';

const PaymentLinkCompletePage = () => {
    const state = React.useContext(CheckoutStateContext);
    const {impulseByClaim} = useImpulseByClaimTicketingComplete({state});
    const {serviceLink, impulseByAuthorizedUser, impulseStateDescription, setImpulseStateDescription} = useTicketingComplete({state});
    const {
        downloadSuccessfullImpulseFiles,
        singleDownloadLinkRef,
        showDownloadPopUp,
        setShowDownloadPopUp,
        filesToDownload
    } = useDownloadTicketingComplete({state});
    return (
        <div className={`checkout-pl-complete checkout-pl-complete--${impulseStateDescription.name}`} data-insights-object-id={impulseByClaim.impulseService.service.id}>
            <CompleteContainer>
                <CompleteContent>
                    <impulseStateDescription.Icon/>
                    <CompleteDescription {...{title: impulseStateDescription.title, message: impulseStateDescription.message}}/>
                    <impulseStateDescription.Actions {...{downloadSuccessfullImpulseFiles, serviceLink, showWalletButtonSuccess: !!impulseByAuthorizedUser}}/>
                    {impulseByClaim && impulseByClaim.status < 3 && <ImpulseStatusSubscription {...{claim: impulseByClaim.claim, setImpulseStateDescription}}/>}
                    <a ref={singleDownloadLinkRef} className='display-none' target='_blank'/>
                </CompleteContent>
                <CompleteFooter/>
                <TicketingDownloadPopUp {...{filesToDownload, showDownloadPopUp, setShowDownloadPopUp: () => setShowDownloadPopUp(false)}}/>
            </CompleteContainer>
        </div>
    )
};

export default React.memo(PaymentLinkCompletePage);
